let language = {
    BULK_ORDER_LIST_NO_SELECTED_COMBINE_ITEM_TIP: "No selected combine order items",
    BULK_ORDER_LIST_COMBINE_ORDER_EMPTY: "Your combine order list is empty.",
    BULK_ORDER_LIST_LOAD_MORE_BUTTON: "Load More...",
    BULK_ORDER_LIST_SELECT_ITEM_CHECKOUT: "You have not selected any orders to combine. Please check and select at least one item",

    BULK_ORDER_LIST_SHIPPING_ADDRESS_NOT_SUPPORT: "The shipping address is in a restricted or sanctioned region. Please remove this address and try again.",
    BULK_ORDER_LIST_NOT_HAVE_VAT_CONFIG: "Missing VAT information prevented combined checkout. Please provide your VAT details and try again.",
    // BULK_ORDER_LIST_NOT_HAVE_VAT_CONFIG_TEXT1: "Please",
    // BULK_ORDER_LIST_NOT_HAVE_VAT_CONFIG_TEXT2: "click here",
    // BULK_ORDER_LIST_NOT_HAVE_VAT_CONFIG_TEXT3: "to enter your VAT ID.",

    BULK_ORDER_LIST_SHIPPING_ADDRESS_VERIFY_FAIL: "The shipping address or postal code appears to be invalid. Please review and update it.",
    BULK_ORDER_LIST_CURRENCY_NOT_SUPPORT: "The selected currency is not supported. Please change the currency and try again.",
    BULK_ORDER_LIST_CURRENCY_EMPTY: "No currency has been set for this order. Please select a currency and try again.",
};

export { language }